export var PermissionScope;
(function (PermissionScope) {
    PermissionScope["SIGN"] = "sign";
    PermissionScope["OPERATION_REQUEST"] = "operation_request";
    PermissionScope["ENCRYPT"] = "encrypt";
    PermissionScope["THRESHOLD"] = "threshold"; // Allows the DApp to sign transactions below a certain threshold. This is currently not fully defined and unused
})(PermissionScope || (PermissionScope = {}));
//# sourceMappingURL=PermissionScope.js.map